// /**
//  * Fleet - Add
//  */

// React
import React, { useState } from 'react';

// react hook form
import { useForm } from 'react-hook-form';

// UI
import theme from '../../../theme';
import { makeStyles, Theme, createStyles } from '@material-ui/core/styles';
import {
  TextField,
  Grid,
  Button,
  CircularProgress,
  Paper,
  Typography,
  Select,
  MenuItem,
  InputLabel,
  FormControl,
  Checkbox,
  ListItemText,
} from '@material-ui/core';
import Autocomplete from '@material-ui/lab/Autocomplete';
import jMoment from 'moment-jalaali';

// Icon
import Icon from '@mdi/react';
import {
  mdiPhoneOutline,
  mdiAccountTieOutline,
  mdiMapMarkerOutline,
  mdiPlus,
  mdiPackageVariantClosed,
  mdiCalendar,
  mdiArrowRight,
  mdiPrinter,
  mdiCalendarClock,
  mdiFormatListCheckbox,
  mdiWarehouse,
  mdiAccountOutline,
  mdiClose,
  mdiArchiveOutline,
  mdiCheck,
  mdiCarMultiple,
  mdiCarInfo,
  mdiClipboardAccountOutline,
  mdiAccountCashOutline,
  mdiTrainCar,
} from '@mdi/js';

// Type
import { SelectorProps } from './interfaces';

// helpers'
import {
  flattenObject,
  removeEmptyValueObject,
  translate,
} from '../../../utils/helpers';
import { createFleetsAction } from '../actions';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import { Store } from '../../../redux/reducers';
import { makeSelectError, makeSelectLoading } from '../selectors';

import { Payload, VehicleType } from '../interfaces';

jMoment.loadPersian({ dialect: 'persian-modern', usePersianDigits: true });

type Props = {
  onClose: () => void;
  createFleetDispatch?: (payload: Payload) => void;
};

type Inputs = {
  agentName: string;
  agentPhoneNumber: string;
  name: string;
  phoneNumber: string;
  agentPosition: string;
};

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      display: 'flex',
      flexWrap: 'wrap',
    },
    paper: {
      marginLeft: '20px',
      marginRight: '20px',
      paddingBottom: theme.spacing(3),
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2),
      '@media (max-width: 768px)': {
        padding: theme.spacing(0),
        backgroundColor: theme.palette.background.default,
      },
    },
    // Cancel Dialog
    cancelIcon: {
      textAlign: 'center',
      position: 'relative',
      paddingLeft: theme.spacing(8),
      marginBottom: theme.spacing(7),

      '&::before': {
        content: '""',
        position: 'absolute',
        width: '100px',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%,-50%)',
        height: '100px',
        borderRadius: '50%',
        opacity: '0.2',
        backgroundColor: theme.palette.success.main,
      },
    },
    cancelTitle: {
      fontSize: '16px',
      fontWeight: 500,
      textAlign: 'center',
      lineHeight: 2,
      marginBottom: theme.spacing(3),
    },
    actionsBox: {
      paddingTop: theme.spacing(2),
      paddingRight: theme.spacing(3),
      paddingLeft: theme.spacing(3),
    },
    headerBox: {
      display: 'flex',
      alignItems: 'center',
      marginBottom: '28px',
    },
    margin: {
      // margin: theme.spacing(1),
    },
    withoutLabel: {
      marginTop: theme.spacing(3),
    },
    textInput: {
      // width: '25ch',
      '& input, .MuiSelect-root': {
        padding: '6px 0 12px !important',
      },

      '& .MuiInput-underline::before': {
        borderBottom: '1px solid #d8d8d8 !important',
      },
    },
    errorText: {
      color: '#F30000',
      fontSize: '11px',
    },
    item: {
      display: 'flex',
      alignSelf: 'center',
      alignItems: 'center',
      fontWeight: 500,
      width: '100%',
      '& > *': {
        // margin: theme.spacing(0, 0, 0, 1),
      },
    },
    icon: {
      color: '#8a8a8a',
      marginRight: theme.spacing(1),
    },
    label: {
      display: 'flex',
      alignItems: 'center',
      fontSize: '14px',
      fontWeight: 400,
      color: '#8a8a8a',
      marginRight: '8px',
      marginTop: '21px',
    },
    addIcon: {
      textAlign: 'center',
      position: 'relative',
      paddingLeft: theme.spacing(8),
      // marginBottom: theme.spacing(7),
      '&::before': {
        content: '""',
        position: 'absolute',
        width: '100px',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%,-50%)',
        height: '100px',
        borderRadius: '50%',
        opacity: '0.2',
        backgroundColor: theme.palette.green.main,
      },
    },
    closeButton: {
      position: 'absolute',
      right: theme.spacing(1),
      top: theme.spacing(1),
      color: theme.palette.grey[500],
    },
  })
);

function Index(props: Props) {
  const classes = useStyles();
  const { register, handleSubmit, errors, watch, setValue, getValues } = useForm<
    Inputs
  >({
    mode: 'onChange',
    defaultValues: {},
  });
  const [type, setType] = useState<any>('');
  const [settlementType, setSettlementType] = useState<any>('');
  const [vehicleClasses, setVehicleClasses] = useState<any>([]);

  const vehicleTypes = [
    'CAR',
    'MOTORCYCLE',
    'PICKUPS',
    'TRUCK',
    'HEAVY_TRUCK',
    'AIRPLANE',
  ];

  const settlementTypes = ['WEEKLY', 'MONTHLY', 'DAILY', 'YEARLY'];
  const types = ['PROPRIETARY', 'THIRD_PARTY'];

  const checkEmptyInputs = (): boolean => {
    const values = [vehicleClasses, settlementType, type];
    const emptyValues =
      Object.keys(flattenObject(removeEmptyValueObject({ ...watch() })))
        .length !== 5;
    return emptyValues && values.some(value => !value);
  };

  const onSubmit = (data: Inputs) => {
    const {
      agentName,
      agentPhoneNumber,
      agentPosition,
      name,
      phoneNumber,
    } = data;

    const inputData = {
      agentName,
      agentPosition,
      agentPhoneNumber,
      name,
      phoneNumber,
      vehicleClasses,
      settlementType,
      type,
      status: 'ACTIVE',
    };
    handleCreateParcel(inputData);
  };

  const handleChangeDeliverType = (
    event: React.ChangeEvent<{ value: unknown }>
  ) => {
    setType(event.target.value as string);
  };

  const handleCreateParcel = (parcelsData: any) => {
    props.createFleetDispatch({
      body: parcelsData,
      callback: props.onClose,
    });
  };

  const values = getValues();

  return (
    <>
      <form style={{ display: 'flex' }} onSubmit={handleSubmit(onSubmit)}>
        <Grid container style={{ margin: 0 }} spacing={5} alignItems="flex-start">
          <div className={classes.paper}>
            <Grid
              style={{ padding: '0 20px' }}
              container
              spacing={5}
              alignItems="flex-start"
            >
              <Grid container item xs={12} sm={6} alignItems="flex-end">
                <div className={classes.item}>
                  <span className={classes.label}>
                    <Icon
                      path={mdiCarMultiple}
                      size={1}
                      className={classes.icon}
                    />
                  </span>
                  <Grid item xs={11}>
                    <TextField
                      fullWidth
                      id="name"
                      name="name"
                      label="نام ناوگان"
                      className={classes.textInput}
                      inputRef={register({
                        required: true,
                        minLength: 5,
                        maxLength: 25,
                      })}
                      error={errors.name && true}
                    />
                    {errors.name && errors.name.type === 'required' && (
                      <p className={classes.errorText}>
                        {'فیلد نام الزامیست'}
                      </p>
                    )}
                    {errors.name && errors.name.type === 'minLength' && (
                      <p className={classes.errorText}>
                        {'مقدار نام نباید کمتر از 5 کاراکتر باشد'}
                      </p>
                    )}
                    {errors.name && errors.name.type === 'maxLength' && (
                      <p className={classes.errorText}>
                        {'مقدار نام نباید بیشتر از 25 کاراکتر باشد'}
                      </p>
                    )}
                  </Grid>
                </div>
              </Grid>
              <Grid container item xs={12} sm={6} alignItems="flex-end">
                <div className={classes.item}>
                  <span className={classes.label}>
                    <Icon
                      path={mdiPhoneOutline}
                      size={1}
                      className={classes.icon}
                      style={{ transform: 'scale(-1, 1)' }}
                    />
                  </span>
                  <Grid item xs={11}>
                    <TextField
                      fullWidth
                      id="phoneNumber"
                      name="phoneNumber"
                      label="شماره تماس"
                      className={classes.textInput}
                      inputRef={register({
                        required: true,
                        pattern: /^([+]+98|0)\d{5,10}$/g,
                        minLength: 11,
                        maxLength: 15,
                      })}
                      error={errors.phoneNumber && true}
                    />
                    {errors.phoneNumber && errors.phoneNumber.type === 'required' && (
                      <p className={classes.errorText}>
                        {'فیلد شماره تماس الزامیست'}
                      </p>
                    )}
                    {errors.phoneNumber && errors.phoneNumber.type === 'pattern' && (
                      <p className={classes.errorText}>
                        {'فرمت فیلد شماره تماس صحیح نیست'}
                      </p>
                    )}
                    {errors.phoneNumber && errors.phoneNumber.type === 'minLength' && (
                      <p className={classes.errorText}>
                        {'مقدار شماره تماس نباید کمتر از 11 کاراکتر باشد'}
                      </p>
                    )}
                    {errors.phoneNumber && errors.phoneNumber.type === 'maxLength' && (
                      <p className={classes.errorText}>
                        {'مقدار شماره تماس نباید بیشتر از 15 کاراکتر باشد'}
                      </p>
                    )}
                  </Grid>
                </div>
              </Grid>
              <Grid container item xs={6} sm={6} alignItems="flex-end">
                <div className={classes.item}>
                  <span className={classes.label}>
                    <Icon path={mdiCarInfo} size={1} className={classes.icon} />
                  </span>

                  <span style={{ width: '100%' }}>
                    <FormControl style={{ width: '100%' }}>
                      <InputLabel id="typeLabel">نوع ناوگان</InputLabel>
                      <Select
                        fullWidth
                        id="type"
                        name="type"
                        inputProps={{
                          name: 'type',
                          id: 'type',
                        }}
                        labelId="typeLabel"
                        value={type}
                        onChange={handleChangeDeliverType}
                        className={classes.textInput}
                        inputRef={register({ required: true })}
                      >
                        {types.map((item: any) => {
                          return (
                            <MenuItem key={item} value={item}>
                              {translate(item, 'fleet')}
                            </MenuItem>
                          );
                        })}
                      </Select>
                    </FormControl>
                  </span>
                </div>
              </Grid>{' '}
              <Grid container item xs={12} sm={6} alignItems="flex-end">
                <div className={classes.item}>
                  <span className={classes.label}>
                    <Icon
                      path={mdiAccountOutline}
                      size={1}
                      className={classes.icon}
                    />
                  </span>

                  <div style={{ width: '100%' }}>
                    <TextField
                      fullWidth
                      id="agentName"
                      name="agentName"
                      label="نام نماینده ناوگان"
                      className={classes.textInput}
                      inputRef={register({
                        required: true,
                        minLength: 5,
                        maxLength: 25,
                      })}
                      error={errors.agentName && true}
                    />
                    {errors.agentName && errors.agentName.type === 'required' && (
                      <p className={classes.errorText}>
                        {'فیلد نام نماینده ناوگان الزامیست'}
                      </p>
                    )}
                    {errors.agentName && errors.agentName.type === 'minLength' && (
                      <p className={classes.errorText}>
                        {'مقدار نام نماینده ناوگان نباید کمتر از 5 کاراکتر باشد'}
                      </p>
                    )}
                    {errors.agentName && errors.agentName.type === 'maxLength' && (
                      <p className={classes.errorText}>
                        {'مقدار نام نماینده ناوگان نباید بیشتر از 25 کاراکتر باشد'}
                      </p>
                    )}
                  </div>
                </div>
              </Grid>
              <Grid container item xs={12} sm={6} alignItems="flex-end">
                <div className={classes.item}>
                  <span className={classes.label}>
                    <Icon
                      path={mdiClipboardAccountOutline}
                      size={1}
                      className={classes.icon}
                    />
                  </span>
                  <Grid item xs={11}>
                    <TextField
                      fullWidth
                      id="agentPosition"
                      name="agentPosition"
                      label="سمت نماینده ناوگان"
                      className={classes.textInput}
                      inputRef={register({
                        required: true,
                        minLength: 5,
                        maxLength: 25,
                      })}
                      error={errors.agentPosition && true}
                    />
                    {errors.agentPosition && errors.agentPosition.type === 'required' && (
                      <p className={classes.errorText}>
                        {'فیلد سمت نماینده ناوگان الزامیست'}
                      </p>
                    )}
                    {errors.agentPosition && errors.agentPosition.type === 'minLength' && (
                      <p className={classes.errorText}>
                        {'مقدار سمت نماینده ناوگان نباید کمتر از 5 کاراکتر باشد'}
                      </p>
                    )}
                    {errors.agentPosition && errors.agentPosition.type === 'maxLength' && (
                      <p className={classes.errorText}>
                        {'مقدار سمت نماینده ناوگان نباید بیشتر از 25 کاراکتر باشد'}
                      </p>
                    )}
                  </Grid>
                </div>
              </Grid>
              <Grid container item xs={6} sm={6} alignItems="flex-end">
                <div className={classes.item}>
                  <span className={classes.label}>
                    <Icon
                      path={mdiPhoneOutline}
                      size={1}
                      className={classes.icon}
                      style={{ transform: 'rotate(-90deg)' }}
                    />
                  </span>

                  <span style={{ width: '100%' }}>
                    <TextField
                      fullWidth
                      id="agentPhoneNumber"
                      name="agentPhoneNumber"
                      label="شماره تماس نماینده ناوگان"
                      className={classes.textInput}
                      inputRef={register({
                        required: true,
                        pattern: /^([+]+98|0)\d{5,10}$/g,
                        minLength: 11,
                        maxLength: 15,
                      })}
                      error={errors.agentPhoneNumber && true}
                    />
                    {errors.agentPhoneNumber && errors.agentPhoneNumber.type === 'required' && (
                      <p className={classes.errorText}>
                        {'فیلد شماره تماس نماینده ناوگان الزامیست'}
                      </p>
                    )}
                    {errors.agentPhoneNumber && errors.agentPhoneNumber.type === 'pattern' && (
                      <p className={classes.errorText}>
                        {'فرمت فیلد شماره تماس نماینده ناوگان صحیح نیست'}
                      </p>
                    )}
                    {errors.agentPhoneNumber && errors.agentPhoneNumber.type === 'minLength' && (
                      <p className={classes.errorText}>
                        {'مقدار شماره تماس نماینده ناوگان نباید کمتر از 11 کاراکتر باشد'}
                      </p>
                    )}
                    {errors.agentPhoneNumber && errors.agentPhoneNumber.type === 'maxLength' && (
                      <p className={classes.errorText}>
                        {'مقدار شماره تماس نماینده ناوگان نباید بیشتر از 15 کاراکتر باشد'}
                      </p>
                    )}
                  </span>
                </div>
              </Grid>
              <Grid container item xs={6} sm={6} alignItems="flex-end">
                <div className={classes.item}>
                  <span className={classes.label}>
                    <Icon
                      path={mdiTrainCar}
                      size={1}
                      className={classes.icon}
                    />
                  </span>

                  <span style={{ width: '100%' }}>
                    <FormControl style={{ width: '100%' }}>
                      <InputLabel id="vehicleClassesLabel">
                        نوع خودروهای ناوگان
                      </InputLabel>
                      <Select
                        fullWidth
                        id="vehicleClasses"
                        name="vehicleClasses"
                        inputProps={{
                          name: 'vehicleClasses',
                          id: 'vehicleClasses',
                        }}
                        multiple
                        labelId="vehicleClassesLabel"
                        renderValue={(selected: any) => {
                          const nameSelectedItem = vehicleTypes.filter(
                            (type: any) => selected.includes(type)
                          );

                          return nameSelectedItem
                            .map((nameSelect: any) =>
                              translate(nameSelect)
                            )
                            .join(',');
                        }}
                        value={vehicleClasses}
                        onChange={e => setVehicleClasses(e.target.value)}
                        className={classes.textInput}
                        inputRef={register({ required: true })}
                      >
                        {vehicleTypes.map((item: any) => (
                          <MenuItem key={item} value={item}>
                            <Checkbox
                              checked={vehicleClasses.indexOf(item) > -1}
                            />
                            <ListItemText
                              primary={translate(item)}
                            />
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </span>
                </div>
              </Grid>
              <Grid container item xs={6} sm={6} alignItems="flex-end">
                <div className={classes.item}>
                  <span className={classes.label}>
                    <Icon
                      path={mdiAccountCashOutline}
                      size={1}
                      className={classes.icon}
                    />
                  </span>

                  <span style={{ width: '100%' }}>
                    <FormControl style={{ width: '100%' }}>
                      <InputLabel id="settlementTypeLabel">
                        نوع تسویه
                      </InputLabel>
                      <Select
                        fullWidth
                        id="settlementType"
                        name="settlementType"
                        inputProps={{
                          name: 'settlementType',
                          id: 'settlementType',
                        }}
                        labelId="settlementTypeLabel"
                        value={settlementType}
                        onChange={e => setSettlementType(e.target.value)}
                        className={classes.textInput}
                        inputRef={register({ required: true })}
                      >
                        {settlementTypes.map((item: any) => {
                          return (
                            <MenuItem key={item} value={item}>
                              {translate(item)}
                            </MenuItem>
                          );
                        })}
                      </Select>
                    </FormControl>
                  </span>
                </div>
              </Grid>
            </Grid>
          </div>
          <Grid item container xs={12} spacing={3}>
            <Grid item xs={6}>
              <Button
                type="submit"
                fullWidth
                size="large"
                data-cy="search"
                autoFocus
                variant="contained"
                color="secondary"
                disabled={checkEmptyInputs()}
              >
                {'ایجاد ناوگان جدید'}
              </Button>
            </Grid>
            <Grid item xs={6}>
              <Button
                fullWidth
                type="button"
                size="large"
                variant="contained"
                onClick={props.onClose}
              >
                {'انصراف'}
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </form>
    </>
  );
}

const mapStateToProps = createStructuredSelector<Store, SelectorProps>({
  loading: makeSelectLoading(),
  error: makeSelectError(),
});

function mapDispatchToProps(dispatch: Function) {
  return {
    createFleetDispatch: (payload: Payload) =>
      dispatch(createFleetsAction(payload)),
  };
}
const withConnect = connect(mapStateToProps, mapDispatchToProps);
export default compose(withConnect)(Index);
